<template>
  <div class="add">
    <div class="add_top">
      <div class="img_box" @click="imgClick()">
        <img v-if="img.length != 0 && !loading" :src="img" alt="" />
        <input
          style="float: left; display: none"
          type="file"
          id="uploadFile"
          accept="image/*"
          @change="readLocalFile()"
        />
        <van-icon
          v-if="img.length == 0 && !loading"
          name="plus"
          size=".44rem"
        />
        <van-loading v-if="loading" type="spinner" />
      </div>
      <div class="name">点击添加宣传图片</div>
    </div>
    <div class="add_bottom">
      <van-cell-group>
        <van-field v-model="title" label-width="1rem" label="标题" />
        <van-field
          v-model="dec"
          label-width="1rem"
          autosize
          rows="2"
          type="textarea"
          label="描述"
        />
        <van-field
          v-model="wangzhi"
          label-width="1rem"
          label="网址"
          placeholder="请输入你的广告网址"
        />
      </van-cell-group>
    </div>
    <div class="btn" @click="submit">确认添加</div>
    <van-overlay :show="show" class="overlay"
      ><van-loading type="spinner"
    /></van-overlay>
  </div>
</template>

<script>
import { Icon, Field, CellGroup, Loading, Toast, Overlay } from "vant";
import { getUploadImageNew, getVideoAdNew } from "@/api/public";
export default {
  name: "advertisngList",
  components: {
    [Icon.name]: Icon,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Loading.name]: Loading,
    [Overlay.name]: Overlay
  },
  data() {
    return {
      ad_id: "",
      id: "",
      key: "",
      img: "",
      loading: false,
      title: "",
      dec: "",
      wangzhi: "",
      show: false,
      item: ""
    };
  },
  mounted: function() {
    this.key = this.$route.query.secret_key;
    this.id = this.$route.query.id;
    if (this.$route.query.item) {
      this.item = JSON.parse(this.$route.query.item);
      console.log(this.item);
      this.img = this.item.ad_image;
      this.title = this.item.ad_name;
      this.dec = this.item.ad_describe;
      this.wangzhi = this.item.video_url;
      this.ad_id = this.item.id;
    }
  },
  methods: {
    /**
     * 上传图片
     */
    imgClick() {
      document.getElementById("uploadFile").click();
    },
    /**
     * 点击选中图片
     */
    readLocalFile() {
      this.loading = true;
      var param = new FormData();
      let files = event.target.files[0];
      param.append("file", files, files.name); //  append 中的 字符串名称 根据后端接口提示修改
      getUploadImageNew(param)
        .then(res => {
          console.log(res);
          this.img = res.data.url;
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
          Toast({ message: err.msg });
        });
    },
    /**
     * 提交修改
     */
    submit() {
      if (this.img.length == 0) {
        Toast({ message: "请添加图片" });
        return;
      }
      if (this.title.length == 0) {
        Toast({ message: "请添加标题" });
        return;
      }
      if (this.dec.length == 0) {
        Toast({ message: "请添加描述" });
        return;
      }
      if (this.wangzhi.length != 0) {
        let re = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;
        if (!re.test(this.wangzhi)) {
          Toast({ message: "网址格式不正确" });
          return;
        }
      }
      this.show = true;
      getVideoAdNew({
        ad_name: this.title,
        ad_image: this.img,
        ad_describe: this.dec,
        video_url: this.wangzhi,
        ad_id: this.ad_id,
        secret_key: this.key
      })
        .then(res => {
          setTimeout(() => {
            this.show = false;
            Toast({ message: res.msg });
            this.$router.push({
              path: "/video/index",
              query: {
                id: this.id
              }
            });
          }, 1000);
        })
        .catch(err => {
          this.show = false;
          Toast({ message: err.msg });
        });
    }
  }
};
</script>

<style lang="scss">
.add {
  .add_top {
    padding: 0.3rem;
    background: #ffffff;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .img_box {
      width: 1rem;
      height: 1rem;
      background: #f5f5f5;
      border-radius: 0.06rem;
      font-size: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 0.01rem solid #e9e9e9;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .name {
      width: calc(100% - 1rem);
      padding-left: 0.2rem;
      font-size: 0.32rem;
    }
  }
  .add_bottom {
    margin-top: 0.2rem;
  }
  .btn {
    margin: 0.2rem 0.3rem 0 0.3rem;
    text-align: center;
    line-height: 0.8rem;
    border-radius: 0.14rem;
    background: #ff410a;
    color: #ffffff;
    font-size: 0.32rem;
  }
  .overlay {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
